module.exports = __webpack_public_path__ + "static/aerial-2e9bebb80eea9221db9cd94272af5437.jpg";